import axios from "axios";

export default {
  namespaced: true,

  state: {
    all: [],
  },

  actions: {
    index({ commit }) {
      return axios.get(process.env.VUE_APP_API_URL + 'settings')
        .then(({ data }) => {
          commit('setItems', [
            {
              name: {
                nl: 'Wielen',
                en: 'Wheels',
                de: 'Räder',
              },
              price: data.wheels_price || 0,
              selected: false,
            },
          ]);
        });
    },
  },

  getters: {
    getAll(state) {
      return state.all;
    },
  },

  mutations: {
    setItems(state, array) {
      state.all = array;
    },

    setSelected(state, {bool}) {
      state.all.selected = bool;
    },
  },
}
